
<div class="container" style="border:1px solid #bebaba">
  <br />

  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Court Documents</h3>
      <p>Below are links to certain Court documents relating to the Action and the Settlement.</p>
      <ul>
        <!--<li>
          <a href="../../../assets/documents/1-Initial Class Action Complaint.pdf"
             target="_blank">
            Initial Class Action Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/3_Corrected Class Action Complaint.pdf"
             target="_blank">
            Corrected Class Action Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/44_Second Amended Class Action Complaint.pdf"
             target="_blank">
            Second Amended Class Action Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/63_Third Amended Class Action Complaint.pdf"
             target="_blank">
            Third Amended Class Action Complaint
          </a>
        </li>-->
        <li>
          <a href="../../../assets/documents/102_FourthAmended Class Action Complaint.pdf"
             target="_blank">
            Fourth Amended Class Action Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/195_Notice of Motion and Motion for Preliminary Approval of Settlement.pdf"
             target="_blank">
            Notice of Motion and Motion for Preliminary Approval of Settlement of Class Action and to Direct Notice to the Settlement Class
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/198_Order Granting Prelim Approval.pdf"
             target="_blank">
            Order Granting Preliminary Approval of Settlement and Directing Notice to the Class
          </a>
        </li>
        <ul>
          <li>
            <a href="../../../assets/documents/198-1_Exhibit A Stipulation and Agreement of Settlement.pdf"
               target="_blank">
              Exhibit A - Stipulation and Agreement of Settlement
            </a>
          </li>
        </ul>
        <!--<ul>
          <li>
            <a href="../../../assets/documents/195-1_ MEMO ISO MOTION FOR PRELIMINARY APPROVAL.pdf"
               target="_blank">
              Memorandum in Support of Motion for Preliminary Approval of  Settlement of Class Action and to Direct Notice to the Settlement Class
            </a>
          </li>
          <li>
            <a href="../../../assets/documents/195-2_ JT DEC OF CO-LEAD COUNSEL ISO MOTION FOR PRELIM APPROVAL.pdf"
               target="_blank">
              Joint Declaration of Co-Lead Counsel in Support of Motion for Preliminary Approval of  Settlement of Class Action and to Direct Notice to the Settlement Class
            </a>
          </li>
          <li>
            <a href="../../../assets/documents/195-3_Declaration of EP ISO Motion for Prelim Approval.pdf"
               target="_blank">
              Declaration of Elaine Pang in Support of Plaintiffs’ Motion for Preliminary Approval
            </a>
          </li>
          <ul>
            <li>
              <a href="../../../assets/documents/195-3a_Elaine Pang Resume.pdf"
                 target="_blank">
                Exhibit A - Curriculum Vitae of Elaine Pang
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3b_ABData Resume.pdf"
                 target="_blank">
                Exhibit B - Profile of A.B. Data, Ltd.
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3c_Summary Notice.pdf"
                 target="_blank">
                Exhibit C - Short-Form Notice
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3d_Long Form Notice.pdf"
                 target="_blank">
                Exhibit D - Long-Form Notice
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3e_Banner Ad.pdf"
                 target="_blank">
                Exhibit E - Sample Banner Ads
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3f_Claim Form.pdf"
                 target="_blank">
                Exhibit F - Proposed Claim Form
              </a>
            </li>
            <li>
              <a href="../../../assets/documents/195-3g-Claimscore Resume.pdf"
                 target="_blank">
                Exhibit G - Profile of Claimscore
              </a>
            </li>
          </ul>

        </ul>-->
        <!--<li>
          <a href="../../../assets/documents/195-4_[PROPOSED] ORDER GRANTING PRELIMINARY APPROVAL OF SETTLEM.pdf"
             target="_blank">
            [Proposed] Order Granting Preliminary Approval of Settlement and Directing Notice to the Class
          </a>
        </li>
        <li>
          <a href="../../../assets/documents/197-[Corrected] Jt Dec of Co Lead Counsel ISO Motion for Prelim Approval.pdf"
             target="_blank">
            [Corrected] Joint Declaration of Co-Lead Counsel in Support of Motion for Preliminary Approval of
            Settlement and to Direct Notice to the Settlement Class
          </a>
        </li>-->

      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
